<div class="overlay"></div>

<div class="panel">
  <div class="inside-panel" [formGroup]="form">
    <div class="header">
      <h2>{{ title }}</h2>
      @if (isEditMode && stsUsername) {
        <p class="subtitle">
          Username attuale: <strong>{{ stsUsername }}</strong>
        </p>
      }
    </div>

    <div class="content">
      @if (isCreateMode) {
        <div class="info-row">
          <mat-icon>lock_open</mat-icon>
          <div class="info-text">
            <div class="info-text-title">
              Credenziali STS non ancora configurate
            </div>
            <div class="info-text-body">
              Compila tutti i campi qui sotto per salvare per la prima volta
              username, password e PIN STS.
            </div>
          </div>
        </div>
      }

      @if (isEditMode) {
        <div class="info-row">
          <mat-icon>lock</mat-icon>
          <div class="info-text">
            <div class="info-text-title">Credenziali STS già configurate</div>
          </div>
        </div>
      }

      <div class="form-row">
        <mat-form-field appearance="fill">
          <mat-label>Username STS</mat-label>
          <input
            matInput
            formControlName="sts_username"
            [placeholder]="usernamePlaceholder"
            autocomplete="off"
          />
        </mat-form-field>
      </div>

      <!-- Creazione: tutti i campi visibili -->
      @if (isCreateMode) {
        <div class="form-row">
          <mat-form-field appearance="fill">
            <mat-label>Password STS</mat-label>
            <input
              matInput
              [type]="showStsPassword ? 'text' : 'password'"
              formControlName="sts_password"
              [placeholder]="passwordPlaceholder"
              autocomplete="new-password"
            />
            <button
              matSuffix
              mat-icon-button
              type="button"
              (click)="togglePasswordVisibility.emit()"
              [attr.aria-label]="
                showStsPassword ? 'Nascondi password' : 'Mostra password'
              "
            >
              <mat-icon>
                {{ showStsPassword ? "visibility_off" : "visibility" }}
              </mat-icon>
            </button>
          </mat-form-field>
        </div>
        <div class="form-row">
          <mat-form-field appearance="fill">
            <mat-label>PIN STS</mat-label>
            <input
              matInput
              [type]="showStsPin ? 'text' : 'password'"
              formControlName="sts_pin"
              [placeholder]="pinPlaceholder"
              autocomplete="off"
            />
            <button
              matSuffix
              mat-icon-button
              type="button"
              (click)="togglePinVisibility.emit()"
              [attr.aria-label]="showStsPin ? 'Nascondi PIN' : 'Mostra PIN'"
            >
              <mat-icon>
                {{ showStsPin ? "visibility_off" : "visibility" }}
              </mat-icon>
            </button>
          </mat-form-field>
        </div>
      } @else {
        <div class="form-row">
          <div class="toggle-row">
            <div class="field-title">
              <mat-icon>lock_reset</mat-icon>
              <span>Password STS</span>
            </div>
            <button
              mat-stroked-button
              type="button"
              class="sts-toggle-button"
              (click)="toggleEditPassword()"
            >
              {{ isPasswordEditing ? "Annulla modifica" : "Cambia password" }}
            </button>
          </div>
          @if (isPasswordEditing) {
            <mat-form-field
              appearance="fill"
              [@expandCollapse]
              class="edit-field"
            >
              <mat-label>Nuova password STS</mat-label>
              <input
                matInput
                [type]="showStsPassword ? 'text' : 'password'"
                formControlName="sts_password"
                [placeholder]="passwordPlaceholder"
                autocomplete="new-password"
              />
              <button
                matSuffix
                mat-icon-button
                type="button"
                (click)="togglePasswordVisibility.emit()"
                [attr.aria-label]="
                  showStsPassword ? 'Nascondi password' : 'Mostra password'
                "
              >
                <mat-icon>
                  {{ showStsPassword ? "visibility_off" : "visibility" }}
                </mat-icon>
              </button>
            </mat-form-field>
          }
        </div>
        <div class="form-row">
          <div class="toggle-row">
            <div class="field-title">
              <mat-icon>pin</mat-icon>
              <span>PIN STS</span>
            </div>
            <button
              mat-stroked-button
              type="button"
              class="sts-toggle-button"
              (click)="toggleEditPin()"
            >
              {{ isPinEditing ? "Annulla modifica" : "Cambia PIN" }}
            </button>
          </div>
          @if (isPinEditing) {
            <mat-form-field
              appearance="fill"
              [@expandCollapse]
              class="edit-field"
            >
              <mat-label>Nuovo PIN STS</mat-label>
              <input
                matInput
                [type]="showStsPin ? 'text' : 'password'"
                formControlName="sts_pin"
                [placeholder]="pinPlaceholder"
                autocomplete="off"
              />
              <button
                matSuffix
                mat-icon-button
                type="button"
                (click)="togglePinVisibility.emit()"
                [attr.aria-label]="showStsPin ? 'Nascondi PIN' : 'Mostra PIN'"
              >
                <mat-icon>
                  {{ showStsPin ? "visibility_off" : "visibility" }}
                </mat-icon>
              </button>
            </mat-form-field>
          }
        </div>
      }

      <!-- Modifica: password/PIN nascosti finché l'utente non decide di cambiarli -->
    </div>

    <div class="panel-buttons">
      <button
        class="button-white"
        mat-stroked-button
        type="button"
        (click)="close.emit()"
        [disabled]="isSaving"
      >
        Annulla
      </button>
      <button
        class="button-white"
        mat-raised-button
        type="button"
        (click)="save.emit()"
        [disabled]="isSaving"
      >
        @if (isSaving) {
          <mat-icon class="spinner-icon">autorenew</mat-icon>
        }
        @if (!isSaving) {
          <span>Salva</span>
        }
        @if (isSaving) {
          <span>Salvataggio...</span>
        }
      </button>
    </div>
  </div>
</div>
